import {
  IcoActivity16,
  IcoArrowCircleDashed16,
  IcoBank16,
  IcoBolt16,
  IcoBranch24,
  IcoBuilding16,
  IcoCheckCircle16,
  IcoCode16,
  IcoCode216,
  IcoConnections16,
  IcoCreditcard16,
  IcoCrosshair16,
  IcoDollar16,
  IcoEye16,
  IcoFileText16,
  IcoFileText216,
  IcoFootprintShield16,
  IcoGlobe16,
  IcoIdCard16,
  IcoLayer0116,
  IcoLock16,
  IcoLogOut16,
  IcoSparkles16,
  IcoSsnCard16,
  IcoUser16,
  IcoUserCircle16,
  IcoVisaPassport16,
  IcoWriting16,
} from '@onefootprint/icons';
import type { NodeIconProps } from './node-icon';

/**
 * Shared icon configurations for nodes.
 * Used by both useGetStaticNodeInfo (for existing nodes) and useGetNewNodeContext (for adding nodes).
 */
export const nodeIconConfigs = {
  // Data collection
  identityData: { Icon: IcoUserCircle16, color: 'info' },
  businessData: { Icon: IcoBuilding16, color: 'info' },
  customData: { Icon: IcoWriting16, color: 'info' },
  investorProfile: { Icon: IcoDollar16, color: 'info' },
  collectCard: { Icon: IcoCreditcard16, color: 'info' },
  bankLink: { Icon: IcoBank16, color: 'info' },
  authentication: { Icon: IcoLock16, color: 'info' },

  // Documents
  identityDocument: { Icon: IcoIdCard16, color: 'info' },
  customDocument: { Icon: IcoFileText216, color: 'info' },
  proofOfAddress: { Icon: IcoBuilding16, color: 'info' },
  proofOfSsn: { Icon: IcoSsnCard16, color: 'info' },
  selfie: { Icon: IcoUserCircle16, color: 'info' },

  // Decision
  verificationCheck: { Icon: IcoFootprintShield16, color: 'primary' },
  conditional: { Icon: IcoLayer0116, color: 'accent' },
  rules: { Icon: IcoLayer0116, color: 'primary' },
  branch: { Icon: IcoBranch24, color: 'accent' },
  action: { Icon: IcoBolt16, color: 'primary' },

  // Advanced
  externalApi: { Icon: IcoActivity16, color: 'primary' },
  vendorIntegration: { Icon: IcoConnections16, color: 'primary' },
  prerequisite: { Icon: IcoCode16, color: 'primary' },
  output: { Icon: IcoLogOut16, color: 'primary' },
  complete: { Icon: IcoCheckCircle16, color: 'primary' },
  inputSchema: { Icon: IcoCode216, color: 'primary' },
  assignData: { Icon: IcoArrowCircleDashed16, color: 'primary' },
  commonExpression: { Icon: IcoCode216, color: 'primary' },
  codeExec: { Icon: IcoCode216, color: 'primary' },
  verifiedPrefill: { Icon: IcoUserCircle16, color: 'info' },
  taktile: { Icon: IcoActivity16, color: 'primary' },

  // Percy AI
  watchlistReview: { Icon: IcoEye16, color: 'primary' },
  documentExtraction: { Icon: IcoFileText16, color: 'primary' },
  aiResearch: { Icon: IcoCrosshair16, color: 'primary' },
  aiDecision: { Icon: IcoCrosshair16, color: 'primary' },
  aiAgent: { Icon: IcoSparkles16, color: 'primary' },

  // Recipes
  ssnMiskey: { Icon: IcoSsnCard16, color: 'info' },
  underAgeBranch: { Icon: IcoUser16, color: 'info' },
  countryKycIdDoc: { Icon: IcoGlobe16, color: 'info' },
  einDocument: { Icon: IcoVisaPassport16, color: 'info' },
  documentNameMatching: { Icon: IcoFileText16, color: 'info' },
  basicKyc: { Icon: IcoUser16, color: 'info' },
  basicKyb: { Icon: IcoBuilding16, color: 'info' },

  // Other
  placeholder: { Icon: IcoLayer0116, color: 'primary' },
  joinPoint: { Icon: IcoBranch24, color: 'accent' },
  boKyc: { Icon: IcoUserCircle16, color: 'info' },
  emptyBranch: { Icon: IcoLayer0116, color: 'primary' },
} as const satisfies Record<string, NodeIconProps>;

export type NodeIconConfigKey = keyof typeof nodeIconConfigs;
